angular.module('aprima-legacy-common').factory('aprgettext', ['gettextCatalog', function (gettextCatalog) {
    'use strict';

    //This is a hack. gettext can extract strings from js files much like it can from html files.
    //To do this it searches for code that looks like "gettext('....')" and extracts the string.
    //gettext() however simple returns the string, and doesn't actually translate the string.
    //To do this, you have to pass that string to gettextCatalog.getString(), but that prevents
    //it from being extracted by the grunt task. The official usage is:
    //var translated = gettextCatalog.getString(gettext('Some String'));
    //but this usage is overly verbose.
    //This hack makes it so that you can use it like:
    //var translated = gettext('Some String');

    //When taking a dependency on this, make sure the variable is named 'gettext' and not 'apr_gettext'

    //usage of this should be limited. Most code should be in views. This is useful when calling window.alert
    //or toaster.pop();
    //todo we should review this and see if anybody has a better solution.
    return function (text) {
        return gettextCatalog.getString(text);
    };
}]);
